import type { AccountTypeEnum } from './account.enum'

export class Account {
    accountId: string
    companyId: string
    label: string
    createdAt: Date
    updatedAt: Date
    type: AccountTypeEnum
    bank?: string
    branch?: string
    account?: string
    status: number
    pluggyId: string
    pluggyLastSync?: Date
    source?: string
}
